export default __webpack_public_path__ + "static/media/trr-food-salad-arugula.294834a9.png";